import { render } from "./addEmployee.vue?vue&type=template&id=81bbc170&scoped=true"
import script from "./addEmployee.vue?vue&type=script&lang=js"
export * from "./addEmployee.vue?vue&type=script&lang=js"

import "./addEmployee.vue?vue&type=style&index=0&id=81bbc170&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81bbc170"]])

export default __exports__